function CampusInfo({ campus, careers, image }) {

  return (
    <section className="bg-light">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-7 col-md-12 col-sm-12 pt-2 pb-3">
            {image && 
              <div className="align-items-start d-flex justify-content-center">
                <img src={image} alt={campus.name} className="img-fluid rounded" />
              </div>
            }
            <p className="py-2">
              El {campus.name} se encuentra ubicado en la {campus.location.address}.
            </p>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12 pt-2">
            <div className="pt-1 pb-2">
              {careers && careers.length > 0 && (
                <>
                  <p>Esta sede ofrece las siguientes carreras:</p>
                  <ul className="lists lists-3 pb-2 ps-4" role="tablist">
                    {careers.map((career) => (
                      <li key={career.id}>
                        <a href={`/carreras/${career.id}`}>{career.name}</a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
            <div className="ps-4">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a className="btn btn-primary mb-3 h-25" href="#" onClick={() => window.open(campus.location.map, '_blank')}>
                <i className="bi bi-geo-alt pe-2"></i>
                Ubicación en el mapa
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CampusInfo;
